import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { AvaluoApp } from './AvaluoApp';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import 'animate.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AvaluoApp />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
